import React from 'react';
import CheckboxInput from 'shared/components/CheckboxInput';

const Title = ({id, name, title, product_url, checked, onChange}) => (
  <div className="form-check accessory-title-block">
    <CheckboxInput
      id={id}
      name={name}
      groupName=''
      inputClassName='form-check-input'
      checked={checked}
      onChange={onChange}/>
    <label className="form-check-label accessory-title text-uppercase" htmlFor={name}>
      <a href={product_url} target="_blank" rel="noreferrer">
        {title}
      </a>
    </label>
  </div>
);

export default Title;
